<template>
  <div class="SalesReadForm">
    <el-form ref="form" :model="form" :rules="rules" inline>
      <el-col :span="8"> <el-form-item label="编号" prop="fBillNo">
        <el-input v-model="form.fBillNo" disabled />
      </el-form-item></el-col>
      <el-col :span="8"> <el-form-item label="年份" prop="fYear">
        <el-input v-model="form.fYear" disabled />
      </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="月份" prop="fMonth">
          <el-input v-model="form.fMonth" disabled />
        </el-form-item>
      </el-col>
    </el-form>
    <el-table :data="form.infoEntrys" class="tb-edit" style="width: 100%" highlight-current-row>
      <el-table-column label="经销商" width="180">
        <template scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="销售额度(元)" width="200">
        <template scope="scope" :style="{'display': (display? 'none':'block')}">
          <!-- <el-input-number v-model="scope.row.fQuota" size="small" placeholder="请输入内容" :style="{'display': (display?'block' :'none')}" :min="0" /> <span :style="{'display': (display? 'none':'block')}">{{ scope.row.fQuota }}</span>
          -->
          <el-input-currency v-model="scope.row.fQuota" :scale="2" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="备注" :style="{'display': (display? 'none':'block')}">
        <template scope="scope">
          <el-input v-model="scope.row.fDes" size="small" placeholder="请输入内容" :style="{'display': (display?'block' :'none')}" :min="0" />
          <!-- <span :style="{'display': (display? 'none':'block')}">{{ scope.row.fDes }}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template scope="scope">
          <el-button v-if="!display" size="small" @click="editOpen()">编辑</el-button>
          <el-button v-if="display" size="small" @click="handleEdit(scope.$index, scope.row)">取消编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        type: [{ required: true, message: '必填项', trigger: 'change' }],
        fCreateTime: [
          { required: true, message: '必填项', trigger: 'change' }
        ]
      },
      display: true,
      isReadonly: true
    }
  },
  mounted: function() {
  },
  methods: {
    submit: function(onValid) {
      this.$refs.form.validate(valid => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    },
    handleCurrentChange(row, event, column) {
      // console.log(row, event, column, event.currentTarget)
    },
    handleEdit(index, row) {
      this.form.infoEntrys[index] = row
      this.display = false
      this.isReadonly = true
    },
    editOpen() {
      this.display = true
      this.isReadonly = false
    }
  }
}
</script>

<style lang="less">
// .tb-edit .el-input {
//     display: none
// }
// .tb-edit .current-row .el-input {
//     display: block
// }
// .tb-edit .current-row .el-input+span {
//     display: none
// }
.SalesReadForm{
  .el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
}
</style>
